import { render, staticRenderFns } from "./my-person-data.vue?vue&type=template&id=fac71ae0&scoped=true&"
import script from "./my-person-data.vue?vue&type=script&lang=js&"
export * from "./my-person-data.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac71ae0",
  null
  
)

export default component.exports